import * as z from "zod/v4";

export const deleteTripleWhaleOmsIntegration = {
  name: "deleteTripleWhaleOmsIntegration" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
